import { cn } from "@tine/designsystem-utils";
import { observer } from "mobx-react-lite";
import type { PropsWithChildren } from "react";

const Quote = ({ children }: PropsWithChildren) => {
   const quoteComponentStyle = "my-16 flex flex-col items-center gap-4 md:gap-5";
   const doubleQuotationMarkStyle = "h-12 text-8xl md:text-9xl font-bold font-['InaiMathi']";
   const quoteStyle = "text-center text-2xl md:text-2xl font-semibold [&_p]:mb-0 [&>div]:mx-0 [&>div]:w-full [&>div]:max-w-xl";

   return (
      <blockquote className={cn(quoteComponentStyle, quoteStyle)}>
         <span className={doubleQuotationMarkStyle}>“</span>
         {children}
      </blockquote>
   );
};

export default observer(Quote);
